/**
 * Store global del modal "Crear nuevo prospecto" (IA o manual).
 *
 * El modal `NewProspectChoiceDialog` se monta UNA sola vez en AppLayout y se
 * controla desde acá, así cualquier entry point (botón de la lista de
 * prospectos, Command Palette ⌘K, acciones del dashboard) abre el MISMO modal
 * sin duplicar estado ni componente.
 *
 * Primer uso de Zustand en el repo (dep ya instalada · CLAUDE.md "Zustand para
 * global"). Patrón mínimo: un boolean + acciones.
 */
import { create } from 'zustand';

interface NewProspectModalState {
  open: boolean;
  openModal: () => void;
  closeModal: () => void;
  setOpen: (open: boolean) => void;
}

export const useNewProspectModal = create<NewProspectModalState>((set) => ({
  open: false,
  openModal: () => set({ open: true }),
  closeModal: () => set({ open: false }),
  setOpen: (open) => set({ open }),
}));
